// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { navigationDrawerStyles } from "@vanmeter/Overrides/Components/NavigationDrawer";
import { fontConfig } from "@vanmeter/XDL/constants";
import IconClose from "@vanmeter/XDL/Icons/IconClose";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

const sharedButtonStyles = {
    variant: "link" as any,
    color: "common.ui1",
    hoverStyle: {
        color: "common.ui17",
    },
    activeStyle: {
        color: "common.ui1",
    },
    css: css`
        width: 30px;
        height: 30px;
    `,
};

navigationDrawerStyles.menuTriggerButton = {
    ...sharedButtonStyles,
};

navigationDrawerStyles.drawer = {
    size: 360,
    cssOverrides: {
        headlineTypography: css`
            margin: 0;
        `,
        drawerBody: css`
            top: 0;
            transform: translate(-100%, 0);
            height: 100vh;
            height: 100svh;
            height: 100dvh;
            box-shadow: none;
            padding: 0 0 8px 0;
            background-color: ${color("common.ui1")};
            display: flex;
            flex-direction: column;
            overflow: hidden;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        drawerTitle: css`
            background-color: ${color("primary.main")};
            border-bottom: 3px solid ${color("common.ui8")};
            padding: 12px 16px;
            justify-content: flex-end;
            flex-direction: row-reverse;
            gap: 16px;
        `,
        scrim: css`
            background-color: ${color("common.black", 0.5)};
            height: 100vh;
            height: 100svh;
        `,
        drawerContent: css`
            padding: 8px 0 env(safe-area-inset-bottom, 0px);
            flex: 1;
            min-height: 0;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            position: relative;
        `,
    },
    headlineTypographyProps: {
        variant: "h4",
        forwardAs: "span",
        lineHeight: fontConfig.regular.lineHeight,
        color: "common.white",
    },
    closeButtonProps: {
        ...sharedButtonStyles,
    },
    closeButtonIconProps: {
        src: IconClose,
        size: 22,
    },
};

navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        &.header-link-list,
        &.header-shipTo {
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 0 16px;
        }
    `,
};

navigationDrawerStyles.mainNavigationRow = {};

navigationDrawerStyles.mainNavigationRowTypography = {
    ...fontConfig.smallSingleLine,
    color: "text",
};

navigationDrawerStyles.headerLinkWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
        flex-wrap: wrap;
        ${TypographyStyle} {
            margin-bottom: 0;
        }
    `,
};

navigationDrawerStyles.headerlinklistStyles = {
    typographyProps: { ...fontConfig.smallSingleLine },
};

navigationDrawerStyles.employeeOwnerLinkStyles = {
    typographyProps: { ...fontConfig.smallSingleLine },
    color: "common.ui8",
};

navigationDrawerStyles.panelMenu = {};

navigationDrawerStyles.navigationModeMenu = {
    currencyWrapper: {
        css: css`
            padding: 0 16px;
            margin: 0;
            border: none;
        `,
    },
};
